import View from './View';

export { default as View, getEpisodePickerStyles } from './View';

export default View;
